import { motion, useReducedMotion } from "framer-motion";
import "./FeatureRow.css";

function FeatureRow({ eyebrow, title, description, items, image, visual, reverse }) {
  const prefersReducedMotion = useReducedMotion();
  const slideFrom = reverse ? 40 : -40;

  return (
    <div className={`landing-feature-row${reverse ? " landing-feature-row-reverse" : ""}`}>
      <motion.div
        className="landing-feature-image"
        initial={prefersReducedMotion ? false : { opacity: 0, x: slideFrom, scale: 0.96 }}
        whileInView={{ opacity: 1, x: 0, scale: 1 }}
        viewport={{ once: true, amount: 0.35 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      >
        {visual ? (
          visual
        ) : (
          <div className="landing-mockup-frame">
            <img src={image.src} alt={image.alt} loading="lazy" />
          </div>
        )}
      </motion.div>

      <motion.div
        className="landing-feature-content"
        initial={prefersReducedMotion ? false : { opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
      >
        <span className="landing-eyebrow">{eyebrow}</span>
        <h2>{title}</h2>
        <p>{description}</p>

        <div className="landing-feature-list">
          {items.map((item, i) => (
            <motion.div
              className="landing-feature-item"
              key={item.title}
              initial={prefersReducedMotion ? false : { opacity: 0, x: -12 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.6 }}
              transition={{ duration: 0.4, delay: 0.15 + i * 0.08 }}
            >
              <div className="landing-feature-check">✓</div>
              <div>
                <h4>{item.title}</h4>
                <span>{item.desc}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
}

export default FeatureRow;
